import React, { useEffect, useState } from "react";
import { getDatabase, ref, set } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

export default function AddClientPage({ uid }) {
  const navigate = useNavigate();
  const db = getDatabase();

  const [form, setForm] = useState({
    fullName: "",
    phone: "",
    wilaya: "",
    commune: "",
    address: "",
  });

  const [wilayas, setWilayas] = useState([]);
  const [communesMap, setCommunesMap] = useState([]);
  const [communes, setCommunes] = useState([]);

  // 🔹 تحميل JSON الولايات والبلديات
  useEffect(() => {
    fetch("/algeria_cities.json")
      .then((res) => res.json())
      .then((data) => {
        const map = {};
        const wList = [];

        data.forEach((item) => {
          const w = item.wilaya_name_ascii;
          const c = item.commune_name_ascii;

          if (!map[w]) {
            map[w] = [];
            wList.push(w);
          }
          map[w].push(c);
        });

        // ترتيب القوائم
        Object.keys(map).forEach((w) => map[w].sort());
        setWilayas(wList.sort());
        setCommunesMap(map);
      })
      .catch((err) => console.error("Erreur JSON:", err));
  }, []);

  // 🔹 تحديث قائمة البلديات عند تغيير الولاية
  useEffect(() => {
    if (form.wilaya) {
      setCommunes(communesMap[form.wilaya] || []);
      setForm((prev) => ({ ...prev, commune: "" }));
    } else {
      setCommunes([]);
    }
  }, [form.wilaya, communesMap]);

  // 🔹 حفظ العميل
  const saveClient = async () => {
    if (!form.fullName || !form.phone || !form.wilaya || !form.commune || !form.address) {
      return alert("يرجى تعبئة جميع الحقول");
    }

    const clientId = uuidv4();
    const clientData = {
      uid: clientId,
      ...form,
      createdAt: Date.now(),
    };

    try {
      await set(ref(db, `distributors/${uid}/clientsAdd/${clientId}`), clientData);
      alert("✅ تم إضافة العميل بنجاح");
      navigate("/clients");
    } catch (e) {
      alert("❌ حدث خطأ أثناء الحفظ: " + e.message);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: 12,
    marginBottom: 16,
    borderRadius: 8,
    border: "1px solid #ccc",
    boxSizing: "border-box",
    fontSize: 14,
  };

  const buttonStyle = {
    width: "100%",
    padding: 14,
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 500,
    fontSize: 15,
  };

  return (
    <div style={{ maxWidth: 500, margin: "auto", padding: 24 }}>
      <h2 style={{ textAlign: "center", marginBottom: 24 }}>➕ Ajouter un client</h2>

      {/* الاسم الكامل */}
      <input
        placeholder="Nom complet"
        value={form.fullName}
        onChange={(e) => setForm({ ...form, fullName: e.target.value })}
        style={inputStyle}
      />

      {/* رقم الهاتف */}
      <input
        placeholder="Téléphone"
        value={form.phone}
        onChange={(e) => setForm({ ...form, phone: e.target.value })}
        style={inputStyle}
      />

      {/* Dropdown الولاية */}
      <select
        value={form.wilaya}
        onChange={(e) => setForm({ ...form, wilaya: e.target.value })}
        style={inputStyle}
      >
        <option value="">-- Sélectionner Wilaya --</option>
        {wilayas.map((w) => (
          <option key={w} value={w}>{w}</option>
        ))}
      </select>

      {/* Dropdown البلدية */}
      <select
        value={form.commune}
        onChange={(e) => setForm({ ...form, commune: e.target.value })}
        style={inputStyle}
        disabled={!form.wilaya}
      >
        <option value="">-- Sélectionner Commune --</option>
        {communes.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>

      {/* العنوان */}
      <input
        placeholder="Adresse"
        value={form.address}
        onChange={(e) => setForm({ ...form, address: e.target.value })}
        style={inputStyle}
      />

      {/* زر الحفظ */}
      <button onClick={saveClient} style={buttonStyle}>
        💾 Enregistrer
      </button>
    </div>
  );
}
